import { render, staticRenderFns } from "./CFloatingElement.vue?vue&type=template&id=2a985db9&scoped=true&"
import script from "./CFloatingElement.vue?vue&type=script&lang=js&"
export * from "./CFloatingElement.vue?vue&type=script&lang=js&"
import style0 from "./CFloatingElement.vue?vue&type=style&index=0&id=2a985db9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a985db9",
  null
  
)

export default component.exports